var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-container"
  }, [_c('div', {
    staticClass: "table-wrapper"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', _vm._l(_vm.tableItem.thead, function (thead, h) {
    return _c('th', {
      key: thead
    }, [_vm._v(_vm._s(_vm.tableItem.thead[h]))]);
  }), 0)]), _c('tbody', _vm._l(_vm.tableItem.tbody, function (tr, i) {
    return _c('tr', {
      key: i
    }, [_vm._l(tr, function (td, i) {
      return _c('td', {
        key: i
      }, [_typeof(td) !== 'object' ? [_vm._v(" " + _vm._s(td) + " ")] : [td.download ? _c('a', {
        staticClass: "btn",
        attrs: {
          "href": "#",
          "onclick": "event.preventDefault()"
        }
      }, [_vm._v(" " + _vm._s(td.download) + " "), _c('i', {
        staticClass: "arrow-down-rounded"
      })]) : _vm._e()]], 2);
    }), _vm._l(_vm.tableItem[0].thead, function (thead, h) {
      return _c('th', {
        key: thead
      }, [_vm._v(_vm._s(_vm.tableItem[0].thead[h]))]);
    })], 2);
  }), 0)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }